// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7fa7a36","453":"28f1d482","455":"99b8180f","977":"17146603"}[chunkId] + ".chunk.js";
};